<div id="nodes-text-search-loading" *ngIf="loading">
    <p><i class="fas fa-spinner fa-spin me-2"></i>Cargando...</p>
</div>

<div id="nodes-text-search-error" *ngIf="!loading && error">
    <p class="text-danger"><i class="fa fa-times me-2"></i>Error</p>
</div>

<div id="nodes-text-search" *ngIf="!loading && !error">
    
    <h4 class="mb-4">Buscar texto en nodos</h4>

    <div class="mb-4">
        <label for="text" class="d-block">
            <span class="me-2">Texto a buscar:</span>
            <input type="text" name="text" id="text" [(ngModel)]="text">
        </label>
    </div>

    <div class="mb-4">
        <label for="nodes-search-heading" class="d-block">
            <input type="checkbox" class="me-2" name="nodes-search" id="nodes-search-heading" (change)="updateNodes()" [value]="'heading'">
            <span>Enunciados</span>
        </label>
        <label for="nodes-search-activity-test" class="d-block">
            <input type="checkbox" class="me-2" name="nodes-search" id="nodes-search-activity-test" (change)="updateNodes()" [value]="'activity-test'">
            <span>Actividades / Evaluaciones</span>
        </label>
    </div>

    <div class="mb-4">
        <button class="btn btn-success" (click)="nodesTextSearch()">
            <i class="fas fa-search"></i>
            <span>Buscar</span>
        </button>
    </div>

    <div class="mb-4">
        <div *ngIf="nodesTextSearching">
            <i class="fas fa-spinner fa-spin"></i>
            <span>Buscando...</span>
        </div>
        <div class="text-success" *ngIf="nodesTextSearchSuccess">
            <i class="fas fa-check"></i>
            <span>Búsqueda finalizada correctamente.</span>
        </div>
        <div class="text-danger" *ngIf="nodesTextSearchError">
            <i class="fas fa-times"></i>
            <span>Error</span>
        </div>
    </div>

    <table id="nodes-text-search-results" *ngIf="nodesTextSearchSuccess">
        <thead>
            <tr>
                <th>Nombre</th>
                <th>Tipo</th>
                <th>UA / Lección</th>
                <!-- <th>Ver</th> -->
                <th *ngIf="nodesSearch.includes('activity-test')">Pregunta</th>
                <!-- <th *ngIf="nodesSearch.includes('activity-test')">Opciones</th> -->
                <th *ngIf="nodesSearch.includes('activity-test')">Solución</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let node of nodesSearchResults">
                <td>{{ node.name }}</td>
                <td>{{ node.type }}</td>
                <td>UA{{ node.unit_num }} L{{ node.lesson_num }}</td>
                <td *ngIf="nodesSearch.includes('activity-test')">{{ node.sentence }}</td>
                <!-- <td *ngIf="nodesSearch.includes('activity-test')">{{ node.options }}</td> -->
                <td *ngIf="nodesSearch.includes('activity-test')">{{ node.solution }}</td>
            </tr>
        </tbody>
    </table>

</div>